import React from 'react';

export function ClientTab() {
    return (
        <div>
            <h1>Client Tab</h1>
        </div>
    );
}